import Navbar from '../components/Navbar';
import TopBar from '../components/TopBar';
import { Outlet, useLocation } from 'react-router-dom';
import Home from '../components/Home';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { useState } from 'react';
import ApiOnRouteChange from "../components/ApiOnRouteChange";
import { LibraryProvider } from "../components/LibraryContext";

const Dashboard = () => {
  const location = useLocation();
  const isMainDashboard = location.pathname === "/dashboard";
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        localStorage.removeItem("token");
        navigate("/login", { replace: true });
      }
    } catch (err) {
      localStorage.removeItem("token");
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return (
    <LibraryProvider>
      <div className='dashboard_section'>
        <ApiOnRouteChange />
        <div className={`dashboardbox ${isMenuOpen ? "open_mobile_menu" : ""}`}>
          <div className='navbarLeft'><Navbar toggleMenu={() => setIsMenuOpen(!isMenuOpen)} /></div>
          <div className='main_content'>
            <TopBar isMenuOpen={isMenuOpen} toggleMenu={() => setIsMenuOpen(!isMenuOpen)} />
            <div className='mainData'>

              {isMainDashboard && (
                <Home />
              )}
              <Outlet />
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
    </LibraryProvider>
  );
};

export default Dashboard;
